export default {
    pageName: 'High temperature',
    search: {
        title: '',
        placeholder: 'Search by Name'
    },
    times: 'Times',
    header: {
        detail: 'Detail',
        temp: 'Temperature'
    }
}
